import { getStateWithOnlyOneLevel } from '../../utils/StateSelectorHelper';

function getState(state) {
  return getStateWithOnlyOneLevel(state, 'dailyQuiz');
}

export const quizAvailableSelector = (state) =>
  getState(state).get('quizAvailable');

export const timerDisplaySelector = (state) =>
  getState(state).get('timerDisplay');

export const timerSelector = (state) => getState(state).get('timer');

export const questionsSelector = (state) => getState(state).get('questions');

export const resultsSelector = (state) => getState(state).get('results');

export const getCheckDailyQuizStatusWaiting = (state) =>
  getState(state).get('checkDailyQuizStatusWaiting');

export const getNextQuizIn = (state) => getState(state).get('nextQuizIn');

export const getDailyQuizRunning = (state) =>
  getState(state).get('dailyQuizRunning');

export const getLoadDailyQuizWaiting = (state) =>
  getState(state).get('loadDailyQuizWaiting');

export const getQuiz = (state) => getState(state).get('quiz');

export const getQuizRetake = (state) => getState(state).get('quizRetake');

export const getQualDailyQuiz = (state) => getState(state).get('qualDailyQuiz');

export const getQualDailyQuizRetake = (state) =>
  getState(state).get('qualDailyQuizRetake');

export const getSubmitDailyQuizWaiting = (state) =>
  getState(state).get('submitDailyQuizWaiting');

export const getSubmitDailyQuizSuccess = (state) =>
  getState(state).get('submitDailyQuizSuccess');

export const getDailyTimeOut = (state) => getState(state).get('dailyTimeOut');

export const getProgress = (state) => getState(state).get('progress');

export const getIsQualDailyQuizLoading = (state) =>
  getState(state).get('isQualDailyQuizLoading');

export const getIsSubmitQualDailyQuizLoading = (state) =>
  getState(state).get('isLoadingSubmitQualDailyQuiz');

export const getIsSubmitQualDailyQuizSuccessful = (state) =>
  getState(state).get('isSubmitQualDailyQuizSuccessful');

export const getQualDailyQuizDailyTimeOut = (state) =>
  getState(state).get('qualDailyQuizDailyTimeout');

export const getIsQualDailyQuizRunning = (state) =>
  getState(state).get('isQualDailyQuizRunning');

export const getNextQualDailyQuizIn = (state) =>
  getState(state).get('nextQualDailyQuizIn');

export const getQualDailyQuizProgress = (state) =>
  getState(state).get('qualDailyQuizProgress');
